export default {

    'Accueil' : {
        en : 'Home', fr : 'Accueil'
    },

    'Matières' : {
        en : 'Materials', fr : 'Matières'
    },

    'Projets' : {
        en : 'Projects', fr : 'Projets'
    },

    'Notre métier' : {
        en : 'About', fr : 'Notre métier'
    },
    
    'Direction artistique et site internet : ' : {
        en : 'Art direction and website : ', fr : 'Direction artistique et site internet : '
    },
    
    'Crédits : ' : {
        en : 'Credits : ', fr : 'Crédits : '
    },
    
    'Prochainement' : {
        en : 'Soon', fr : 'Prochainement'
    },
    
    'Designer matériaux' : {
        en : 'Materials designer', fr : 'Designer matériaux'
    }

} 


// WEBPACK FOOTER //
// ./src/etc/language.js